<template>
    <mdb-col sm="4" class="col-no-left-pad">
        <mdb-card>
          <mdb-card-body>
            <mdb-card-title>New</mdb-card-title>
            <mdb-card-text>
                <mdb-list-group class="">
                   
                    
                    <router-link :to="'/content/'+new_content['id_cr']" v-for="(new_content) in new_data ">
                        <mdb-list-group-item :action="true"  v-html="new_content['title']"></mdb-list-group-item>
                    </router-link>
                    
                </mdb-list-group>
                
                
            </mdb-card-text>            
          </mdb-card-body>
        </mdb-card>
    </mdb-col>

</template>

<script>
import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbCol,mdbListGroup, mdbListGroupItem } from 'mdbvue';
  
export default {
    name: 'TagClouds',
    data() {
        return {
            new_data: [],
          
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
           
        };
                
    },
    components: {
            mdbCard,mdbListGroup, mdbListGroupItem,
            mdbCardBody,
            mdbCol,
            mdbCardTitle,
            mdbCardText
        },
    created :function(){        
        this.showNewContent()      
    },
    methods:{
        showNewContent(){ 
            axios.get(this.$store.state.apiUrl+'/new_details',{
                params:{
                    id_language:this.$store.state.languageId,
                    id_company:this.$store.state.companyData['id_company'],
                    id_service:this.$store.state.companyData['id_service']
                    
                }
            })
            .then(response => {
                response = response.data
                //console.log(response);
                this.new_data = response;
                this.$nextTick(function () {
                    
                })
            
            })
            .catch(() => {
                this.tag_data = [];
            });
        }    

    }
}
</script>

<style scoped>
    .badge-color {
        background-color: #67676791 !important;
        margin: 0px 25px 25px 0;
    }
    .col-no-left-pad{
        padding-left: 0px;
        padding-right: 0px;
    }
</style>